export enum PI_ROUTES {
  PROPERTY_INSURANCE = "/property-insurance",
  FIRE_INSURANCE = "/property-insurance/fire-insurance",
  INDUSTRIAL_RISK_POLICY = "/property-insurance/industrial-all-risk-policy",
  ELECTRONIC_EQUP_INS_POLICY = "/property-insurance/electronic-equipment-insurance-policy",
  MACHINERY_BREAKDOWN_INSURANCE = "/property-insurance/machinery-breakdown-insurance",
}
